'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { ArrowRight } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { PRIMARY_CTA } from './cta'

export function StickyMobileCta() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const hero = document.getElementById('hero')
    const pricing = document.getElementById('pricing')
    const footer = document.querySelector('footer')

    if (!hero) return

    let pastHero = false
    const endStates = new Map<Element, boolean>()

    const update = () =>
      setVisible(pastHero && ![...endStates.values()].some(Boolean))

    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        pastHero = !entry.isIntersecting
        update()
      },
      { threshold: 0, rootMargin: '0px 0px -40% 0px' }
    )
    heroObserver.observe(hero)

    const endObservers: IntersectionObserver[] = []
    const watchEnd = (el: Element | null) => {
      if (!el) return
      endStates.set(el, false)
      const obs = new IntersectionObserver(
        ([entry]) => {
          endStates.set(entry.target, entry.isIntersecting)
          update()
        },
        { threshold: 0.1 }
      )
      obs.observe(el)
      endObservers.push(obs)
    }
    watchEnd(pricing)
    watchEnd(footer)

    return () => {
      heroObserver.disconnect()
      endObservers.forEach((o) => o.disconnect())
    }
  }, [])

  return (
    <div
      aria-hidden={!visible}
      // Hidden bar stays out of the tab order too, or its link is a focusable child of aria-hidden
      inert={!visible}
      className={cn(
        'md:hidden fixed inset-x-0 bottom-0 z-50',
        'bg-card/95 backdrop-blur-md border-t border-border',
        'pb-[env(safe-area-inset-bottom)] transition-transform duration-300 ease-out',
        visible ? 'translate-y-0' : 'translate-y-full pointer-events-none'
      )}
    >
      <div className="px-4 py-3">
        <Button
          asChild
          className={cn('group h-12 w-full text-base', PRIMARY_CTA)}
        >
          <Link href="/sign-up">
            <span className="text-nowrap">Get started free</span>
            <ArrowRight className="ml-1 size-4" />
          </Link>
        </Button>
      </div>
    </div>
  )
}
